import { VisualizationType, EditableComponent } from '../../models';
import { VisualizationTypeStrategy } from '../models';

export class Other implements VisualizationTypeStrategy {
  public getEditableComponent(): EditableComponent {
    return {
      visualizationType: VisualizationType.OTHER,
      displayName: 'Other',
      displayIcon: 'Widget.Custom',
    };
  }
}
